// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rect-inside-domino {
  position: relative;
  height: 110%;

  border: 1px solid #20677b;

  flex-grow: 0;
  flex-shrink: 0;
  margin-left: auto;
  margin-right: auto;

}

.text-first-half-domino {
  text-align: right;
  padding: 5px;
}

.text-second-half-domino {
  text-align: left;
  padding: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Domino/styles/InsideDomino.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;;EAEZ,yBAAyB;;EAEzB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".rect-inside-domino {\n  position: relative;\n  height: 110%;\n\n  border: 1px solid #20677b;\n\n  flex-grow: 0;\n  flex-shrink: 0;\n  margin-left: auto;\n  margin-right: auto;\n\n}\n\n.text-first-half-domino {\n  text-align: right;\n  padding: 5px;\n}\n\n.text-second-half-domino {\n  text-align: left;\n  padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
